import { addTask } from 'domain-task'

const PROJECT_NAME = 'SeLogerPagePlan'
const BASE = '/initial/'
const INIT = `${PROJECT_NAME}${BASE}init`

export function init(data) {
  return {
    type: INIT,
    payload:
      data instanceof Array
        ? [...data]
        : {
            ...data,
          },
  }
}

export function fetchInitialData({ data, zone } = {}) {
  return function(dispatch) {
    const task = Promise.resolve(data)
      .then(moduleResults => ({
        moduleResults,
        zone,
      }))
      .then(json => dispatch(init(json)))

    addTask(task)
  }
}

export default function reducer(state = { $ready: false }, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...action.payload,
        $ready: true,
      }
    default:
      return state
  }
}
